<div class="users-container">
    <app-form-row>
      <app-card-sm-container>
        <div class="user-count-container">
          <div>
                <app-label
                    [text]="'Total Appointments'">
                </app-label>
          </div>
          <div class="count-container">
            <label>{{appointmentCount}}</label>
          </div>
        </div>
      </app-card-sm-container>
    </app-form-row>

    <app-form-row>
        <app-label
            ngProjectAs="name"
            [text]="'Doctor ID'">
        </app-label>
        <app-textbox
            [placeholder]="'ObjectID'"
            [maxLength]="30"
            [control]="doctorIDControl">
        </app-textbox>
    </app-form-row>

    <app-button [button]="createAppointmentButton">
    </app-button>
</div>
